var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "BulkOrderbysea" },
    [
      _c("h4", [_vm._v(_vm._s(_vm.$t("i18n_International_Air_mail_order")))]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "OrderQueryConditions",
          attrs: {
            "label-position": _vm.labelPosition,
            model: _vm.OrderQueryConditions
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("i18n_Tracking_number") } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("i18n_please_enter") },
                model: {
                  value: _vm.OrderQueryConditions.OrderCode,
                  callback: function($$v) {
                    _vm.$set(_vm.OrderQueryConditions, "OrderCode", $$v)
                  },
                  expression: "OrderQueryConditions.OrderCode"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("i18n_receving_warehosue") } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("i18n_please_choose") },
                  model: {
                    value: _vm.OrderQueryConditions.InwareHouse,
                    callback: function($$v) {
                      _vm.$set(_vm.OrderQueryConditions, "InwareHouse", $$v)
                    },
                    expression: "OrderQueryConditions.InwareHouse"
                  }
                },
                _vm._l(_vm.warehouseList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: _vm.$t(item.namec), value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("i18n_Order_date") } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  "range-separator": "-",
                  "start-placeholder": _vm.$t("i18n_started_date"),
                  "end-placeholder": _vm.$t("i18n_end_date")
                },
                model: {
                  value: _vm.OrderQueryConditions.EntrustmentData,
                  callback: function($$v) {
                    _vm.$set(_vm.OrderQueryConditions, "EntrustmentData", $$v)
                  },
                  expression: "OrderQueryConditions.EntrustmentData"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("i18n_destination_city") } },
            [
              _c("el-cascader", {
                ref: "changetoFABck",
                staticStyle: { width: "200px" },
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("i18n_please_choose"),
                  options: _vm.houseList,
                  props: _vm.toFBAdataprops
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var node = ref.node
                      var data = ref.data
                      return [
                        _c("span", [_vm._v(_vm._s(data.namec))]),
                        _vm._v(" "),
                        !node.isLeaf ? _c("span") : _vm._e()
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.selectedHouseList,
                  callback: function($$v) {
                    _vm.selectedHouseList = $$v
                  },
                  expression: "selectedHouseList"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "0px" },
              attrs: { type: "primary" },
              on: { click: _vm.onSubmit }
            },
            [_vm._v(_vm._s(_vm.$t("i18n_tracking")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          on: {
            "tab-click": function($event) {
              return _vm.handleClick(_vm.activeName)
            }
          },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        _vm._l(_vm.tabsList, function(item, key) {
          return _c(
            "el-tab-pane",
            {
              key: key,
              attrs: { label: item.staus_desc, name: item.order_status }
            },
            [
              _c(
                "el-table",
                {
                  ref: "multipleTable",
                  refInFor: true,
                  staticStyle: { width: "95%", "margin-left": "32px" },
                  attrs: {
                    border: "",
                    align: "center",
                    data: _vm.tableData,
                    "max-height": "580",
                    "tooltip-effect": "dark",
                    "header-cell-style": { background: "#F3F3F3" }
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: _vm.$t("i18n_Serial_number"),
                      width: "60px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "nos",
                      label: _vm.$t("i18n_tracking_number"),
                      width: "150px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "warehousename",
                      label: _vm.$t("i18n_receving_warehosue"),
                      "show-overflow-tooltip": "",
                      width: "150px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.$t("i18n_shipment_information1"),
                      "show-overflow-tooltip": "",
                      width: "200px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.beforeGoodsList.length
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        trigger: "hover",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "center"
                                          }
                                        },
                                        _vm._l(
                                          scope.row.beforeGoodsList,
                                          function(item, index) {
                                            return _c("div", { key: index }, [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(item.goodsName) +
                                                  "*" +
                                                  _vm._s(item.number) +
                                                  _vm._s(
                                                    _vm.$t("i18n_Pieces")
                                                  ) +
                                                  " " +
                                                  _vm._s(item.cbm) +
                                                  "CBM\n                  " +
                                                  _vm._s(item.weight) +
                                                  "KG\n                "
                                              )
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "name-wrapper",
                                          attrs: { slot: "reference" },
                                          slot: "reference"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                scope.row.beforeGoodsList[0]
                                                  .goodsName
                                              ) +
                                              "*" +
                                              _vm._s(
                                                scope.row.beforeGoodsList[0]
                                                  .number
                                              ) +
                                              _vm._s(_vm.$t("i18n_Pieces")) +
                                              "\n                " +
                                              _vm._s(
                                                scope.row.beforeGoodsList[0].cbm
                                              ) +
                                              "CBM\n                " +
                                              _vm._s(
                                                scope.row.beforeGoodsList[0]
                                                  .weight
                                              ) +
                                              "KG\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.$t("i18n_shipment_information"),
                      "show-overflow-tooltip": "",
                      width: "200px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.goodsList.length
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        trigger: "hover",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "center"
                                          }
                                        },
                                        _vm._l(scope.row.goodsList, function(
                                          item,
                                          index
                                        ) {
                                          return _c("div", { key: index }, [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.goodsName) +
                                                "*" +
                                                _vm._s(item.number) +
                                                _vm._s(_vm.$t("i18n_Pieces")) +
                                                " " +
                                                _vm._s(item.cbm) +
                                                "CBM\n                  " +
                                                _vm._s(item.weight) +
                                                "KG\n                "
                                            )
                                          ])
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "name-wrapper",
                                          attrs: { slot: "reference" },
                                          slot: "reference"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                scope.row.goodsList[0].goodsName
                                              ) +
                                              "*" +
                                              _vm._s(
                                                scope.row.goodsList[0].number
                                              ) +
                                              _vm._s(_vm.$t("i18n_Pieces")) +
                                              " " +
                                              _vm._s(
                                                scope.row.goodsList[0].cbm
                                              ) +
                                              "CBM\n                " +
                                              _vm._s(
                                                scope.row.goodsList[0].weight
                                              ) +
                                              "KG\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c("span", [_vm._v("-")])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.$t("i18n_estimated_cost"),
                      "show-overflow-tooltip": "",
                      width: "150px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    scope.row.costbeforeinfo.amount1
                                      ? scope.row.costbeforeinfo.amount1
                                      : 0.0
                                  ) +
                                  "\n          "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.$t("i18n_actual_cost"),
                      "show-overflow-tooltip": "",
                      width: "150px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    scope.row.costinfo.amount2 != "0.00"
                                      ? scope.row.costinfo.amount2
                                      : "-"
                                  ) +
                                  "\n          "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "status",
                      label: _vm.$t("i18n_Tracking"),
                      "show-overflow-tooltip": "",
                      width: "250px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: _vm.$t("i18n_creation_time"),
                      "show-overflow-tooltip": "",
                      width: "250px"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "operation",
                      label: _vm.$t("i18n_Operation"),
                      align: "center",
                      fixed: "right",
                      width: _vm.typeCode == "F" ? "200px" : "120px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-dropdown",
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "el-dropdown-link",
                                      staticStyle: { cursor: "pointer" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("i18n_Operation"))
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      staticStyle: {
                                        "box-sizing": "border-box",
                                        padding: "6px",
                                        "padding-top": "0px"
                                      },
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      !scope.row.replenishComplete
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              staticStyle: {
                                                width: "62px",
                                                height: "32px",
                                                "line-height": "32px",
                                                background: "#409eff",
                                                color: "#fff",
                                                "border-radius": "5px",
                                                "text-align": "center",
                                                padding: "0px 6px",
                                                "margin-top": "6px"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.addGoods(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "i18n_shipment_instruction"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.replenishComplete
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              staticStyle: {
                                                width: "62px",
                                                height: "32px",
                                                "line-height": "32px",
                                                background: "#67c23a",
                                                color: "#fff",
                                                "border-radius": "5px",
                                                "text-align": "center",
                                                "margin-top": "6px",
                                                padding: "0px 6px"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.orderdetails(
                                                        scope
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "i18n_view_details"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.state == 1
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              staticStyle: {
                                                width: "62px",
                                                height: "32px",
                                                "line-height": "32px",
                                                background: "#f56c6c",
                                                color: "#fff",
                                                "border-radius": "5px",
                                                "text-align": "center",
                                                "margin-top": "6px",
                                                padding: "0px 6px"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.cancelOrder(
                                                        scope.row.nos
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t("i18n_Cancel")
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              scope.row.attachmentsign && _vm.typeCode == "F"
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.getConsign(scope.row)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              查看签收单\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {},
        [
          _c("el-pagination", {
            staticStyle: {
              margin: "20px",
              "margin-left": "32px",
              float: "left"
            },
            attrs: {
              "current-page": _vm.curPageL,
              "pager-count": 5,
              "page-sizes": [10, 20, 30, 40],
              "page-size": _vm.pagesize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("viewOrder", {
        attrs: { fileVisible: _vm.viewVisible, tableData: _vm.fileList },
        on: { closeFileDia: _vm.closeDiaView }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76bdbaf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76bdbaf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/AirOrder/AirOrder.vue
// module id = null
// module chunks = 